import { useNavigate } from "react-router-dom";
import "../css/style.css";
import logo from "../images/minda-logo.png";
import { useState, useEffect } from "react";
import { login } from "../api";

function Login() {
  const navigate = useNavigate();

  // userId can now be mobile OR email
  const [userId, setUserId] = useState("");
  const [pwd, setPwd] = useState("");

  useEffect(() => {
    const token = sessionStorage.getItem("token");
    if (token) {
      navigate("/home", { replace: true });
    }
  }, [navigate]);

  const submitLogin = () => {
    const trimmedId = userId.trim();

    // 1) Basic empty check
    if (!trimmedId) {
      alert("Enter Mobile number or Email as userId");
      return;
    }

    // 2) Detect if it's email or mobile
    const isEmail = trimmedId.includes("@");

    if (isEmail) {
      // Very simple email validation
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(trimmedId)) {
        alert("Please enter a valid email address");
        return;
      }
    } else {
      // Treat as mobile no.
      const mobileRegex = /^\d{7,15}$/;
      if (!mobileRegex.test(trimmedId)) {
        alert("Please enter a valid mobile number (7 to 15 digits)");
        return;
      }
    }

    // 3) Password check
    if (!pwd) {
      alert("Password is required");
      return;
    }

    // 4) Call existing API – backend will decide whether it's email or mobile
    login(trimmedId, pwd).then((resp) => {
      if (resp && resp.success) {
        if (resp.token) {
          sessionStorage.setItem("token", resp.token);
          sessionStorage.setItem("isAdmin", resp.isAdmin);
          sessionStorage.setItem("isDealer", resp.isDealer);
          setTimeout(() => {
            navigate("/home", { replace: true });
          }, 1);
        }
      } else {
        alert(resp?.message || "Login failed");
      }
    });
  };

  return (
    <div className="main-page">
      <div className="login-main">
        <div className="logo">
          <img src={logo} alt="logo" />
        </div>

        <div className="login-wrapper">
          <div className="login-form">
            <div className="title text-center ">
              <h1 className="!text-2xl !font-semibold">Log Into Your Account</h1>
              <p className="text-slate-500 dark:text-zink-200">
                For users outside India, use country code with WhatsApp number for login.
              </p>
            </div>

            <div className="form">
              {/* UserID: Mobile or Email */}
              <div className="form-group username">
                <input
                  type="text"
                  placeholder="Enter Mobile number or Email"
                  tabIndex={0}
                  value={userId}
                  onChange={(e) => setUserId(e.target.value)}
                />
              </div>

              {/* Password */}
              <div className="form-group password">
                <input
                  type="password"
                  placeholder="Enter Password"
                  tabIndex={1}
                  value={pwd}
                  onChange={(e) => setPwd(e.target.value)}
                />
              </div>

              <div className="form-group forgot-password mt-10 p-5">
                <a href="#/forgot-password" style={{ float: "right" }}>
                  Forgot Password?
                </a>
              </div>

              <div className="form-group mt-20">
                <button
                  type="submit"
                  className="btn btn-primary btn-block"
                  onClick={submitLogin}
                >
                  Sign In
                </button>
              </div>
            </div>

            <div className="sign-up text-center mt-20">
              <a href="#/reg">New User?</a> Register with us
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;